import { isEmpty } from 'lodash';
import CardSkeleton from '../card-skeleton';
import Card from './card';
import { CardsTypes } from './prop_types';

const Cards = ({
  cards,
  fetchStatus = 'succeed',
  emptyState = '',
  cardAttrs = {},
}) => (
  <>
    {/* Cards */}
    <ul className="row gy-5">
      {fetchStatus === 'succeed' &&
        cards.map((card) => (
          <li className="col-12 col-sm-6 col-md-4" key={card.title}>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <Card {...cardAttrs} {...card} />
          </li>
        ))}

      {fetchStatus === 'loading' &&
        [...Array(6)].map((e, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className="col-12 col-sm-6 col-md-4" key={index}>
            <CardSkeleton />
          </div>
        ))}
    </ul>

    {/* Empty state */}
    {fetchStatus === 'succeed' && isEmpty(cards) && emptyState}
  </>
);

export default Cards;

Cards.propTypes = CardsTypes;
